const TOKEN_KEY = "portal_token";

// JWT lifecycle — preserved from the original AngularJS service.
export function storeToken(token: string): void {
    try {
        localStorage.setItem(TOKEN_KEY, token);
    } catch {
        // localStorage may be unavailable in private browsing.
    }
}

export function readToken(): string | null {
    try {
        return localStorage.getItem(TOKEN_KEY);
    } catch {
        return null;
    }
}

export function clearToken(): void {
    try {
        localStorage.removeItem(TOKEN_KEY);
    } catch {
        // localStorage may be unavailable in private browsing.
    }
}

// export function logoutAndRedirect(): void {
//     clearToken();
//     window.location.replace(config.PORTAL_LOGIN_URL);
// }

export function parseToken(token: string): { insuredId: string | null; expMs: number | null } {
    try {
        const b64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        const payload = JSON.parse(atob(b64 + "=".repeat((4 - (b64.length % 4)) % 4)));
        return {
            insuredId: typeof payload.insuredId === "string" && payload.insuredId ? payload.insuredId : null,
            expMs: typeof payload.exp === "number" ? payload.exp * 1000 : null,
        };
    } catch {
        return { insuredId: null, expMs: null };
    }
}

/** Returns the token only if it exists and hasn't expired; clears it otherwise. */
export function getValidToken(): string | null {
    const token = readToken();
    if (!token) return null;
    const { expMs } = parseToken(token);
    if (expMs !== null && Date.now() >= expMs) {
        clearToken();
        return null;
    }
    return token;
}